export default __webpack_public_path__ + "static/media/signupBack.ee316e0d.png";